import EncryptionView from '../views/EncryptionView';

const EncryptionContainer = () =>  {
  return (
    <EncryptionView />
  );
};

export default EncryptionContainer;